<!--
 * @Description: 综合绩效管理-员工绩效考核表
 * @Author: maqinghe 
 * @Date: 2023年06月27日 13:09:41
-->
<template>
  <div class="workscore-detail atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="month-title">
        <h2 v-if="detail.year">{{ detail.year }}{{ periods[detail.period] }} / {{ detail.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="tab atb-flex atb-flex-justify-between">
        <tab-pane :defaultIndex="currentTab" :tab-list="tabList" iconStyle="top" @getCurrent="getCurrent"></tab-pane>
      </div>
      <div v-show="currentTab === 0" class="search-and-content atb-flex atb-flex-column" id="all">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <!-- <el-form-item>
                <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
              </el-form-item> -->
              <!-- 展开收起放开时需要关闭表格的虚拟滚动 -->
              <!-- <el-form-item>
                <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column kpi">
          <vxe-table
            class="atb-table header-table edit-table border-table disable-ellipsis"
            border="full"
            height="100%"
            auto-resize
            resizable
            :data="tableData"
            ref="workScoreTable"
            :merge-cells="mergeCells"
            :row-class-name="setRowClass"
            :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
            @edit-closed="editClosed"
            @edit-actived="activeRow"
            :edit-rules="validRules"
          >
            <vxe-table-column field="_none" width="40" :edit-render="{ enabled: colCase, autofocus: '.el-textarea__inner' }">
              <template #default="scope">
                <template v-if="scope.rowIndex === 0">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandNewKpi" :class="[expandNewKPIStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandNewKpi">新增KPI工作</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + 1">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandImportantKPI" :class="[expandImportantKPIStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandImportantKPI">重要KPI工作</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + 2">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandBussiness" :class="[expandBussinessStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandBussiness">综合业务性工作</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 3">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">杰出案例</div>
                  </div>
                </template>
                <template v-else-if="scope.row.isOutstandingCase">
                  <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.outstandingCase }}</div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 5">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">自评等级</div>
                  </div>
                </template>
                <template v-else-if="scope.row.isSelf">
                  <div class="atb-flex atb-flex-justify-between atb-flex-items-center">
                    <el-radio-group class="radio-group" v-model="detail.selfEvaluation" @change="updateSelf('selfEvaluation')">
                      <el-radio v-for="(item, i) in selfLevels" :label="item.label" :key="i">{{item.label}}</el-radio>
                    </el-radio-group>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 7">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">
                      <span>综合评分</span>
                      <!-- <span>(</span>
                      <el-popover
                        width="600"
                        trigger="hover"
                      >
                        <span slot="reference" class="rank-tip">评分标准</span>
                        <table class="rank-tip-table">
                          <thead>
                            <tr>
                              <th width="60" align="center">标准</th>
                              <th width="80" align="center">分值区间</th>
                              <th align="center">标准说明</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td align="center">出色</td>
                              <td align="center">100</td>
                              <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                            </tr>
                            <tr>
                              <td align="center">优良</td>
                              <td align="center">90</td>
                              <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                            </tr>
                            <tr>
                              <td align="center">可接受</td>
                              <td align="center">80</td>
                              <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                            </tr>
                            <tr>
                              <td align="center">需改进</td>
                              <td align="center">70</td>
                              <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                            </tr>
                            <tr>
                              <td align="center">不良</td>
                              <td align="center">60<br/>30<br/>0</td>
                              <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                            </tr>
                          </tbody>
                        </table>
                      </el-popover>
                      <span>)</span> -->
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.row.isSup">
                  <div class="atb-flex atb-flex-justify-between atb-flex-items-center">{{ detail.supScore }}</div>
                </template>
                <template v-else>
                  
                </template>
              </template>
              <template #edit="{ row, rowIndex }">
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 4">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 8 }"
                    placeholder="请输入内容"
                    v-model="detail.outstandingCase"
                    @blur="updateSelf('outstandingCase')"
                  ></el-input>
                </template>
                <template v-else-if="row.isSup">
                  <el-input
                    v-model.trim="detail.supScore"
                    type="textarea"
                    :autosize="{ maxRows: 1 }"
                    resize="none"
                    maxlength="5"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => supScoreChange(val)"
                  ></el-input>
                  <!-- <el-autocomplete @change="regScore(row)" v-model.trim="row.score" :fetch-suggestions="scoreSearch"></el-autocomplete> -->

                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column field="source" width="50" title="月份">
              <template #default="{row}">
                <span v-if="row.source">{{ row.source }}月</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="60"
              width="100"
              field="workItemCategory"
              title="类别"
              :edit-render="{ name: 'ElAutocomplete', enabled: colCategory, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
              </template>
              <template #edit="{ row }">
                <el-autocomplete v-model.lazy="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                  <template slot-scope="{ item }">
                    <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                      <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                    </el-tooltip>
                  </template>
                </el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="150"
              field="workItemContent"
              title="工作项目"
              :edit-render="{ enabled: colWorkItem, autofocus: '.el-textarea__inner' }"
            >
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.workItemContent"
                ></el-input>
              </template>
              <template #default="scope">
                <div class="atb-flex atb-flex-items-center">
                  <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}</div>
                </div>
              </template>
            </vxe-table-column>
  
            <vxe-table-column
              min-width="80"
              width="250"
              field="wholeTarget"
              title="总目标"
              :edit-render="{ enabled: colTarget, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
              </template>
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.wholeTarget"
                ></el-input>
              </template>
            </vxe-table-column>
            
            <vxe-table-column min-width="80" width="250" field="reason" title="总结" :edit-render="{ enabled: colSummary, autofocus: '.el-textarea__inner' }">
              <template #default="{row, rowIndex}">
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 5">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">自评原因</div>
                  </div>
                </template>
                <template v-else-if="row.isSelf">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.selfEvaluationReason }}</div>
                </template>
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 7">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">综合评价</div>
                  </div>
                </template>
                <template v-else-if="row.isSup">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.supEvaluation }}</div>
                </template>
                <template v-else>
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
                </template>
              </template>
              <template #edit="{ row }">
                <!-- 自评原因 -->
                <template v-if="row.isSelf">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 2 }"
                    placeholder="请输入内容"
                    v-model="detail.selfEvaluationReason"
                    @blur="updateSelf('selfEvaluationReason')"
                  ></el-input>
                </template>
                <!-- 综合评价 -->
                <template v-else-if="row.isSup">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 2 }"
                    placeholder="请输入内容"
                    v-model="detail.supEvaluation"
                    @blur="growUpSave('supEvaluation')"
                  ></el-input>
                </template>
                <template v-else>
                  <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="240" field="selfAppraise" title="自我对工作完成情况进行评估" :edit-render="{ autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.selfAppraise }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.selfAppraise"></el-input>
              </template>
            </vxe-table-column>

            <vxe-table-column field="" title="操作" fixed="right" width="100" class-name="operation">
              <template #default="scope">
                <div v-if="scope.row.type === 0 || scope.row.type === 5 || scope.row.type === 10">
                  <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                    <i v-throttle class="icon-baocun" @click.stop="saveEditRow(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
            
          </vxe-table>
        </div>
      </div>
      <div v-show="currentTab === 1" class="search-and-content atb-flex atb-flex-column" id="normal">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <el-form-item>
                <el-button :disabled="pending" type="primary" @click="savePersonal">保存</el-button>
              </el-form-item>
              <!-- <el-form-item v-if="isApproved">
                <el-button :disabled="pending" type="downloadTemplate" plain @click="confirmScore(1)">确认</el-button>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column normal">
          <table class="personal-table">
            <thead>
              <tr class="label-row">
                <td width="25%"><div class="personal-label">绩效平均分(自动计算仅参考)</div></td>
                <td width="25%"><div class="personal-label">绩效得分(满分100分)</div></td>
                <td width="25%"><div class="personal-label">企业文化导向得分(满分100分)</div></td>
                <td width="25%"><div class="personal-label">个人成长得分(满分100分)</div></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span>{{ detail.avgkpi }}</span></td>
                <!-- <td>
                  <div class="default-score" @click="avgFocusField()" v-if="avgkpiScore">{{ detail.avgkpi }}</div>
                  <el-input
                    v-else
                    ref="avgkpi"
                    v-model.trim="detail.avgkpi"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => avgScoreChange(val)"
                    @blur="avgBlurField()"
                  ></el-input>
                </td> -->
                <td>
                  <div class="default-score" @click="toFocusField(100)" v-if="defaultScore[100]">{{ personalForm[100] }}</div>
                  <el-input
                    v-else
                    ref="score100"
                    v-model.trim="personalForm[100]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 100)"
                    @blur="blurField(100)"
                  ></el-input>
                </td>
                <td>
                  <div class="default-score" @click="toFocusField(110)" v-if="defaultScore[110]">{{ personalForm[110] }}</div>
                  <el-input
                    v-else
                    ref="score110"
                    v-model.trim="personalForm[110]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 110)"
                    @blur="blurField(110)"
                  ></el-input>
                </td>
                <td>
                  <div class="default-score" @click="toFocusField(120)" v-if="defaultScore[120]">{{ personalForm[120] }}</div>
                  <el-input
                    v-else
                    ref="score120"
                    v-model.trim="personalForm[120]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 120)"
                    @blur="blurField(120)"
                  ></el-input>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label">上级对该员工主要优缺点的总结</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span>优点：</span>
                    <el-checkbox-group class="checkbox-group" v-model="personalForm.advantage" @change="checkedAdvantageChange">
                      <el-checkbox v-for="item in personalAdvantages" :label="item" :key="item.value">{{item}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="other-field">
                    <el-input
                      :maxlength="$config.input.textareaMaxLength - 300"
                      type="textarea" :autosize="{ maxRows: 6 }"
                      rows="1"
                      v-model="personalForm.otherAdvantage"
                      @blur="growUpSave('advantage')"
                      placeholder="其他优点"
                      :disabled="otherAdvantageDisabled"
                    ></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span>缺点：</span>
                    <el-checkbox-group class="checkbox-group" v-model="personalForm.disadvantage" @change="checkedDisadvantageChange">
                      <el-checkbox v-for="item in personalDisadvantages" :label="item" :key="item.value">{{item}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="other-field">
                    <el-input
                      :maxlength="$config.input.textareaMaxLength - 300"
                      type="textarea" :autosize="{ maxRows: 6 }"
                      rows="1"
                      v-model="personalForm.otherDisadvantage"
                      @blur="growUpSave('weakness')"
                      :disabled="otherDisadvantageDisabled"
                      placeholder="其他缺点"
                    ></el-input>
                  </div>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label">员工目前绩效改进情况和存在问题</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label">上期改进计划：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.lastImprovePlan" @blur="growUpSave('lastImprovePlan')"></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label">改进情况：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.improveDetail" @blur="growUpSave('improveDetail')"></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label">存在的问题：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.problem" @blur="growUpSave('problem')"></el-input>
                  </div>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label">员工绩效改进计划</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.improvePlan" @blur="growUpSave('improvePlan')"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
import {
  PERIODS,
  OEC_LEVEL
} from '@/utils/period-enum.js';

export default {
  name: 'ManageWorkscoreDetail',
  mixins: [routeMixin],
  data() {
    const workItemCategory = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"类别"为必填项');
      }
    };
    const workItemContent = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"工作项目"为必填项');
      }
    };
    const wholeTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"总目标"为必填项');
      }
    };
    const reason = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"总结"为必填项');
      }
    };
    const selfAppraise = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('"自我对工作完成情况进行评估"为必填项');
      }
    };


    return {
      validRules: {
        workItemCategory: [{ required: true, validator: workItemCategory, message: '"类别"为必填项' }],
        workItemContent: [{ required: true, validator: workItemContent, message: '"工作项目"为必填项' }],
        wholeTarget: [{ required: true, validator: wholeTarget, message: '"总目标"为必填项' }],
        reason: [{ required: true, validator: reason, message: '"总结"为必填项' }],
        selfAppraise: [{ required: true, validator: selfAppraise, message: '"自我对工作完成情况进行评估"为必填项' }],
      },
      workId: '',
      scoreId: '',
      currentTab: 0,
      tabList: [{ label: '员工绩效考核表', id: 0 }, { label: '员工个人发展部分', id: 1 }],

      mergeCells: [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ],
      categoryList: [],

      cloneTableData: [],
      row: {},
      rowIndex: 0,
      tableColumn: [],
      approveReason: '',
      approveRow: null,
      saveStatus: '',
      timeoutSave: '',
      timeoutAutoSave: '',

      colCategory: true,
      colWorkItem: true,
      colTarget: true,
      colSummary: true,
      colCase: true,

      rowData: {
        "id": null,
        "lastModificationTime": "",
        "lastModifierId": null,
        "scoreId": null,
        "type": 0,
        "source": null,
        "sourceId": "",
        "sourceCreationTime": "",
        "workClassify": 0,
        "workItemNo": "",
        "workItemCategory": "",
        "workItemContent": "",
        "resWkNo": sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
        "resWkName": sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
        "wholeTarget": "",
        "reason": "",
        "selfAppraise": "",
        "appraise": "",
        "score": 0,
        "remark": ""
      },
      
      pending: false,
      expandRowAllFlag: false,

      scoreList: [{ value: 100 }, { value: 90 }, { value: 80 }, { value: 70 }, { value: 60 }, { value: 30 }, { value: 0 }],
      periods: PERIODS,
      status: -1,
      detail: {},
      cloneDetail: {},

      newKPI: [],
      importantKPI: [],
      bussiness: [],
      cloneNewKPI: [],
      cloneImportantKPI: [],
      cloneBussiness: [],
      expandNewKPIStatus: true,
      expandImportantKPIStatus: true,
      expandBussinessStatus: true,

      outstandingCase: '',
      selfEvaluation: '',
      selfEvaluationReason: '',
      selfLevels: OEC_LEVEL,

      itemLimitNums: {
        noImportKPIMax: 20,
        haveImportKPIMax: 5,
        bussinessMax: 1,
        kpiMax: 20
      },
      hasImportKPI: false,

      personalForm: {
        100: '', // 绩效分
        110: '', // 企业文化导向得分
        120: '', // 个人成长得分
        advantage: [], // 优点
        disadvantage: [], // 缺点
        otherAdvantage: '', // 其他-优点
        otherDisadvantage: '', // 其他-缺点
      },
      clonePersonalForm: {},

      advantages: [],
      disadvantages: [],

      submittedAdvantages: [],
      submittedDisadvantages: [],

      defaultScore: {
        100: true,
        110: true,
        120: true,
      },
      avgkpiScore: true

    };
  },
  watch: {
    tableColumnLength() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
      ];
    },

    newKPILength() {
      this.setMerge();
    },
    importantKPILength() {
      this.setMerge();
    },
    bussinessLength() {
      this.setMerge();
    },
    otherLength() {
      this.setMerge();
    },
    
  },
  computed: {
    tableData() {
      return [{}, ...this.newKPI, {}, ...this.importantKPI, {}, ...this.bussiness, {}, { isOutstandingCase: true }, {}, { isSelf: true }, {}, { isSup: true }];
    },
    tableColumnLength() {
      return this.tableColumn.filter((val) => val.visible).length;
    },
    newKPILength() {
      return this.newKPI.length;
    },
    importantKPILength() {
      return this.importantKPI.length;
    },
    bussinessLength() {
      return this.bussiness.length;
    },
    personalAdvantages() {
      return this.submittedAdvantages;
    },
    personalDisadvantages() {
      return this.submittedDisadvantages;
    },
    otherAdvantageDisabled() {
      return !this.personalForm.advantage.includes('其他');
    },
    otherDisadvantageDisabled() {
      return !this.personalForm.disadvantage.includes('其他');
    },

  },
  created() {
    this.scoreId = this.$route.query.id || '';
    this.rowData.scoreId = this.scoreId;
    this.msgId = this.$route.query.msgId || null;

    this.getCategory();
  },
  mounted() {
    this.getLimitNum();
    this.getAdvantageDisAdvantage();
    this.getList();
    this.$nextTick(() => {
      this.tableColumn = (this.$refs.workScoreTable && this.$refs.workScoreTable.getColumns()) || [];
    });
  },
  methods: {
    regScore(row) {
      let val = row.score;
      if(!val) val = '0';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      row.score = val;
    },
    supScoreChange(val) {
      if(!val && val !== 0) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.detail.supScore = val;
      this.growUpSave('supScore');
    },
    getLimitNum() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WorkItemLimitMonth' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            switch (item.itemKey) {
              case 'KPI_NO':
                this.itemLimitNums.noImportKPIMax = item.itemValue ? parseInt(item.itemValue) : 20;
                break;
              case 'KPI_Have':
                this.itemLimitNums.haveImportKPIMax = item.itemValue ? parseInt(item.itemValue) : 5;
                break;
              case 'SumWork':
                this.itemLimitNums.bussinessMax = item.itemValue ? parseInt(item.itemValue) : 1;
                break;
              default:
                break;
            }
          });
        }
      });
    },

    expandRowAll() {
      if (this.expandRowAllFlag) {
        this.tableData.forEach(val => {
          if (val.scoreId){
            val.expandRowFlag = false;
          }
        });
     }else {
        this.tableData.forEach(val => {
          if (val.scoreId){
            val.expandRowFlag = true;
          }
        });
      }
      this.expandRowAllFlag = !this.expandRowAllFlag;
      this.refreshTable();

    },
    expandRow({ rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.refreshTable();
    },
    
    getCurrent(item) {
      this.currentTab = item.data.id;
      if (this.currentTab === 1) {
        this.getNewScore();
      }
    },
    getNewScore() {
      // 更新平均分
      let param = { scoreId: this.scoreId };
      this.$ajax.post(this.$api.period.workScore.detailList, param).then((res) => {
        this.detail.avgkpi = res.data.workE.avgkpi;
      });
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data;
        this.categoryList = this.filterCategory(item);
      });
    },

    querySearch(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      let results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    
    
    expandNewKpi() {
      this.setMerge();
      this.expandNewKPIStatus = !this.expandNewKPIStatus;
      if (this.expandNewKPIStatus) {
        this.newKPI = _.cloneDeep(this.cloneNewKPI);
        this.cloneNewKPI = [];
      } else {
        this.cloneNewKPI = _.cloneDeep(this.newKPI);
        this.newKPI = [];
      }
    },
    expandImportantKPI() {
      this.setMerge();
      this.expandImportantKPIStatus = !this.expandImportantKPIStatus;
      if (this.expandImportantKPIStatus) {
        this.importantKPI = _.cloneDeep(this.cloneImportantKPI);
        this.cloneImportantKPI = [];
      } else {
        this.cloneImportantKPI = _.cloneDeep(this.importantKPI);
        this.importantKPI = [];
      }
    },
    expandBussiness() {
      this.setMerge();
      this.expandBussinessStatus = !this.expandBussinessStatus;
      if (this.expandBussinessStatus) {
        this.bussiness = _.cloneDeep(this.cloneBussiness);
        this.cloneBussiness = [];
      } else {
        this.cloneBussiness = _.cloneDeep(this.bussiness);
        this.bussiness = [];
      }
    },
    expandAll() {
      if (!this.expandNewKPIStatus) {
        this.expandNewKPIStatus = !this.expandNewKPIStatus;
        this.newKPI = _.cloneDeep(this.cloneNewKPI);
      }
      if (!this.expandImportantKPIStatus) {
        this.expandImportantKPIStatus = !this.expandImportantKPIStatus;
        this.importantKPI = _.cloneDeep(this.cloneImportantKPI);
      }
      if (!this.expandBussinessStatus) {
        this.expandBussinessStatus = !this.expandBussinessStatus;
        this.bussiness = _.cloneDeep(this.cloneBussiness);
      }
    },


    getList() {
      if (window._isGetLoading) return;
      window._isGetLoading = true;
      let param = { scoreId: this.scoreId };
      this.$ajax.post(this.$api.period.workScore.detailList, param).then((res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.detailEntitys || [];
        this.detail = res.data.workE;
        this.status = this.detail.status;

        this.newKPI = result.filter(item => item.type === 0);
        this.importantKPI = result.filter(item => item.type === 5);
        this.bussiness = result.filter(item => item.type === 10);
        
        if (this.importantKPI.length > 0) {
          this.itemLimitNums.kpiMax = this.itemLimitNums.haveImportKPIMax;
          this.hasImportKPI = true;
        } else {
          this.itemLimitNums.kpiMax = this.itemLimitNums.noImportKPIMax;
          this.hasImportKPI = false;
        }

        // 员工个人发展 分数
        let classifyScore = res.data.periodClassifyScoreInfo || [];
        if (classifyScore.length === 0) {
          classifyScore = [{workClassify: 100, score: null}, {workClassify: 110, score: null}, {workClassify: 120, score: null}]
        }
        classifyScore.forEach(item => {
          this.personalForm[item.workClassify] = item.score;
        });
        // 优缺点处理
        const advantage = this.detail.advantage ? JSON.parse(this.detail.advantage) : {};
        this.personalForm.advantage = advantage.checkList ? advantage.checkList : [];
        this.personalForm.otherAdvantage = advantage.other;
        this.submittedAdvantages = advantage.list || [];

        const disadvantage = this.detail.weakness ? JSON.parse(this.detail.weakness) : {};
        this.personalForm.disadvantage = disadvantage.checkList ? disadvantage.checkList : [];
        this.personalForm.otherDisadvantage = disadvantage.other;
        this.submittedDisadvantages = disadvantage.list || [];

        this.$nextTick(() => {
          this.refreshTable();
          this.setMerge();
          this.tableColumn = (this.$refs.workScoreTable && this.$refs.workScoreTable.getColumns()) || [];
        });
        if (result.length === 0) {
          this.tableData = [{}, {}, {}, {}, { isOutstandingCase: true }, {}, { isSelf: true }, {}, { isSup: true }];
        } else {
          this.tableData.forEach((val) => {
            val.expandRowFlag = false;
          });
        }
        setTimeout(() => {
          this.cloneTableData = _.cloneDeep(this.tableData);
          this.cloneDetail = _.cloneDeep(this.detail);
          this.clonePersonalForm = _.cloneDeep(this.personalForm);
        });
      }).finally(() => {
        window._isGetLoading = false;
      });
    },
    getAdvantageDisAdvantage() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'PeriodAdvantageWeakness' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            switch (item.itemKey) {
              case 'Advantage':
                var advantage = item.itemValue || '';
                this.advantages = advantage.split(',') || [];
                if (!this.advantages.includes('其他')) {
                  this.advantages.push('其他');
                }
                break;
              case 'Weakness':
                var weakness = item.itemValue || '';
                this.disadvantages = weakness.split(',') || [];
                if (!this.disadvantages.includes('其他')) {
                  this.disadvantages.push('其他');
                }
                break;
              default:
                break;
            }
          });
        }
      });
    },
    setMerge() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength - 1 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 5, rowspan: 1, colspan: this.tableColumnLength - 6 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 5, rowspan: 1, colspan: this.tableColumnLength - 6 },
      ];
    },
    setRowClass({ rowIndex }) {
      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return 'main-row';
      }
    },
    editActived({ row, rowIndex }) {
      this.colCategory = true;
      this.colWorkItem = true;
      this.colTarget = true;
      this.colSummary = true;
      if (row.isOutstandingCase || row.isSup) {
        this.colCase = true;
      } else {
        this.colCase = false;
      }
      if (
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        this.colSummary = false;
      }

      return true;
    },
    editClosed({ row, rowIndex }) {
      this.colCategory = true;
      this.colWorkItem = true;
      this.colTarget = true;
      this.colSummary = true;
      this.colCase = true;

      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return false;
      }
      if (row.isOutstandingCase || row.isSelf || row.isSup) {
        this.tableData[rowIndex].expandRowFlag = false;
        this.refreshTable();
      } else if (rowIndex < this.newKPILength + this.importantKPILength + this.bussinessLength + 3) {
        this.tableData[rowIndex].expandRowFlag = false;
        this.refreshTable();
        this.saveEditRow(row, rowIndex);
      }
    },
    activeRow({ row, rowIndex }) {
      if (row.isOutstandingCase || row.isSelf || row.isSup) return false;
      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return false;
      }
    },
    refreshTable() {
      this.$refs.workScoreTable && this.$refs.workScoreTable.updateData(this.tableData);
    },
    scoreSearch(queryString, cb) {
      let programList = this.scoreList;
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    saveAll() {
      let arr = this.getAllTableData();
      this.$ajax.post(this.$api.period.manage.addOrUpdate, arr, { noLoading: true }).then(() => {
        this.$message.success('保存成功');
      });
      this.saveSelfData();
    },

    saveEditRow(row, rowIndex) {
      if (this.pending) return 0;
      this.cloneTableData[rowIndex]._X_ID = row._X_ID;
      if (_.isEqual(row, this.cloneTableData[rowIndex])) {
        return 0;
      }
      this.pending = true;

      this.$confirm('确定要修改吗', '修改', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.save(row, rowIndex);
      }).catch(() => {
        this.writeRow(this.cloneTableData[rowIndex], rowIndex);
        this.setMerge();
        this.pending = false;
      });
    },
    writeRow(row, index) {
      let item = _.cloneDeep(row);
      if (item.type === 0) {
        if (this.expandNewKPIStatus) {
          this.newKPI.splice(index - 1, 1, item);
        }else{
          this.cloneNewKPI.splice(index - 1, 1, item);
        }
      } else if (item.type === 5) {
        if(this.expandImportantKPIStatus){
          this.importantKPI.splice(index - this.newKPILength - 2, 1, item);
        }else{
          this.cloneImportantKPI.splice(index - this.newKPILength - 2, 1, item);
        }
      } else if (item.type === 10) {
        if(this.expandBussinessStatus){
          this.bussiness.splice(index - this.newKPILength - this.importantKPILength - 3, 1, item);
        }else{
          this.cloneBussiness.splice(index - this.newKPILength - this.importantKPILength - 3, 1, item);
        }
      }
    },

    async save(row, index) {
      let params = this.tableData[index];
      await this.$ajax
        .post(this.$api.period.manage.addOrUpdate, [params])
        .then(() => {
          this.cloneTableData = _.cloneDeep(this.tableData);
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
          this.$nextTick(() => {
            this.setMerge();
          });
        })
        .finally(() => {
          this.pending = false;
        });
    },

    updateSelf(key) {
      if (this.pending) return 0;
      if (this.detail[key] === this.cloneDetail[key]) {
        return false;
      }
      this.pending = true;
      this.$confirm('确定要修改吗', '修改', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.saveSelfData();
      }).catch(() => {
        this.detail[key] = this.cloneDetail[key];
        this.pending = false;
      });
    },
    saveSelfData() {
      this.$ajax
        .post(this.$api.period.manage.selfUpdate, this.detail)
        .then(() => {
          this.cloneDetail = _.cloneDeep(this.detail);
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    
    deleteData(row) {
      this.$confirm('确定要删除吗', '删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.$ajax.delete(this.$api.period.manage.deleteItem + '/' + row.id).then(() => {
          if (row.type === 0) {
            _.remove(this.newKPI, t => t.id == row.id);
            this.newKPI.splice(0, 0);
          } else if (row.type === 5) {
            _.remove(this.importantKPI, t => t.id == row.id);
            this.importantKPI.splice(0, 0);
          } else if (row.type === 10){
            _.remove(this.bussiness, t => t.id == row.id);
            this.bussiness.splice(0, 0);
          }
          this.$message.success('删除成功');
          this.setMerge();
        });
      })
    },

    getAllTableData() {
      //获取所有工作项的数据
      let relResult = [];
      if (this.cloneNewKPI.length) {
        relResult = relResult.concat(this.cloneNewKPI);
      } else {
        relResult = relResult.concat(this.newKPI);
      }
      if (this.cloneImportantKPI.length) {
        relResult = relResult.concat(this.cloneImportantKPI);
      } else {
        relResult = relResult.concat(this.importantKPI);
      }
      if (this.cloneBussiness.length) {
        relResult = relResult.concat(this.cloneBussiness);
      } else {
        relResult = relResult.concat(this.bussiness);
      }
      return relResult;
    },
    scoreChange(val, key) {
      if(!val && val !== 0) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.personalForm[key] = val;

      if (this.personalForm[key] == this.clonePersonalForm[key]) {
        return false;
      }

      this.$confirm('确定要修改吗', '修改', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        let params = [{
          wkNo: this.detail.wkNo,
          wkName: this.detail.wkName,
          year: this.detail.year,
          period: this.detail.period,
          workClassify: key,
          score: this.personalForm[key] || undefined,
        }];
        this.$ajax
          .post(this.$api.period.manage.growUpUpdateClassify, params)
          .then(() => {
            this.clonePersonalForm = _.cloneDeep(this.personalForm);
            this.saveStatus = '已保存';
            this.timeoutSave && clearTimeout(timeoutSave);
            const timeoutSave = setTimeout(() => {
              this.saveStatus = '';
            }, 1000, this);
          });
      }).catch(() => {
        this.personalForm[key] = this.clonePersonalForm[key];
      });
    },
    checkedAdvantageChange() {
      if (!this.personalForm.advantage.includes('其他')) {
        this.personalForm.otherAdvantage = '';
      }
      this.growUpSave('advantage');
    },
    checkedDisadvantageChange() {
      if (!this.personalForm.disadvantage.includes('其他')) {
        this.personalForm.otherDisadvantage = '';
      }
      this.growUpSave('weakness');
    },
    toFocusField(key) {
      this.defaultScore[key] = false;
      this.$nextTick(() => {
        this.$refs['score' + key].focus();
      });
    },
    blurField(key) {
      this.defaultScore[key] = true;
    },

    // 绩效平均分变化
    avgScoreChange(val) {
      if(!val && val !== 0) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.detail.avgkpi = val;
      this.growUpSave('avgkpi');
    },
    avgFocusField() {
      this.avgkpiScore = false;
      this.$nextTick(() => {
        this.$refs['avgkpi'].focus();
      });
    },
    avgBlurField() {
      this.avgkpiScore = true;
    },
    
    growUpSave(key) {
      this.detail.advantage = JSON.stringify({
        checkList: this.personalForm.advantage,
        other: this.personalForm.otherAdvantage,
        list: this.personalAdvantages
      });
      this.detail.weakness = JSON.stringify({
        checkList: this.personalForm.disadvantage,
        other: this.personalForm.otherDisadvantage,
        list: this.personalDisadvantages
      });

      if (this.detail[key] === this.cloneDetail[key]) {
        return false;
      }

      this.$confirm('确定要修改吗', '修改', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.$ajax
        .post(this.$api.period.manage.growUpUpdate, {...this.detail, supScore: this.detail.supScore === '' ? null : this.detail.supScore})
        .then(() => {
          this.cloneDetail = _.cloneDeep(this.detail);
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
        });
      }).catch(() => {
        this.detail[key] = this.cloneDetail[key];
        if (key === 'advantage') {
          // 优缺点处理
          const advantage = this.cloneDetail.advantage ? JSON.parse(this.cloneDetail.advantage) : {};
          this.personalForm.advantage = advantage.checkList ? advantage.checkList : [];
          this.personalForm.otherAdvantage = advantage.other;
        } else if (key === 'weakness') {
          const disadvantage = this.cloneDetail.weakness ? JSON.parse(this.cloneDetail.weakness) : {};
          this.personalForm.disadvantage = disadvantage.checkList ? disadvantage.checkList : [];
          this.personalForm.otherDisadvantage = disadvantage.other;
        }
      });
    },
    savePersonal(){
      if (!this.saveStatus) {
        this.saveStatus = '已保存';
        this.timeoutSave && clearTimeout(timeoutSave);
        const timeoutSave = setTimeout(() => {
          this.saveStatus = '';
        }, 1000, this);
      }
    }

  },
  
};
</script>
<style scoped lang="scss">
.workscore-detail {
  height: 100%;
  .header {
    margin-top: -5px;
    .month-title {
      padding: 0 10px;
      line-height: 30px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
  }
  .container {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
    .tab {
      .el-icon-arrow-down {
        font-size: 12px;
      }
      .open {
        padding-top: 8px;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
    }
    .search-and-content {
      flex: 1;
      overflow: auto;
      .search {
        .function{
          flex-wrap: wrap;
        }
      }
      
      .atb-input {
        display: flex;
        .flex-form-item {
          margin-bottom: 12px;
          display: flex;
          flex: 1;
        }
        .read-mode {
          align-self: flex-end;
        }
        ::v-deep.el-form-item__content {
          flex: 1;
          .el-select,
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }

    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
      .unfinished {
        .vxe-cell{
          color: rgb(254, 107, 104);
        }
      }
    }
    .kpi-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: $--color-primary;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: left;
    .sub-content {
      text-align: center;
    }
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
  .normal-form {
    width: 80%;
  }
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}

::v-deep .el-radio-button {
  margin-right: 20px;
  margin-bottom: 15px;
  .el-radio-button__inner {
    border-radius: 20px;
    padding: 0 20px;
    width: 100%;
    line-height: 36px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
  }
}
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  color: $--color-white;
}

.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}

.personal-table {
  border-collapse: collapse;
  font-size: 14px;
  .label-row {
    background-color: #f6f7fb;
  }
  td {
    padding: 5px 10px;
    border: 1px solid #dcdfe6;
  }
  .personal-label {
    padding: 8px 0;
    color: $--color-primary;
  }

  .checkbox-group {
    display: inline-block;
    margin: 0 10px;
  }
  .other-field {
    margin-top: 8px;
  }
  .area-label {
    white-space: nowrap;
    width: 115px;
  }
  .default-score {
    height: 40px;
    line-height: 40px;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #555;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #555;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $--color-primary;
  }
}
.rank-tip {
  color: $--color-primary;
}
.rank-tip-table {
  border-collapse: collapse;
  font-size: 13px;
  color: #222;
  td, th {
    padding: 10px ;
    border: 1px solid #ccc;
  }
}
.radio-group {
  margin-left: 40px;
}
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    font-size: 14px;
    padding-right: 4px;
    font-family: Verdana, Arial, Tahoma;
    vertical-align: -2px;
  }
}
::v-deep .footer-center .el-dialog__footer {
  text-align: center;
}
</style>
